module.exports = __webpack_public_path__ + "assets/img/icon_style.cc645ad6.png";